/**
 * Helper for browser relative redirect.
 *
 * Use only outside of `<RouterProvider />`.
 *  */
export const browserRelativeRedirect = (url: string): void => void window.location.replace(url)
